<template>
  <div id="jobboard-app">
    <div class="row">
      <div class="small-24 columns">
        <div
          v-if="ready"
          class="row columns"
        >
          <div class="row columns">
            <div class="combo-search">
              <div class="vue-search">
                <label
                  for="search-bar"
                  aria-label="Search Bar"
                >
                  <input
                    id="search-bar"
                    v-model="search"
                    class="search-field"
                    type="text"
                    placeholder="Search by job title or City agency"
                    @keydown.enter="updateResultsList(); "
                    @keyup.enter="hideMobileKeyboard($event); updateResultsList()"
                  >
                  <button
                    v-if="search.length > 0"
                    class="clear-search-btn"
                    @click="clearSearchBar()"
                  >
                    <i class="fas fa-times" />
                  </button>
                  <button
                    class="search-submit"
                    @click="updateResultsList(); showFilterSummary = true;"
                  >
                    <i class="fa-solid fa-magnifying-glass" />
                  </button>
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- Filters -->
            <template v-if="isMq(['md', 'lg'])">
              <div class="columns small-24 medium-7">
                <job-filters
                  :update-results-list="updateResultsList"
                  :clear-all-filters="clearAllFilters"
                  :jobtype.sync="jobtype"
                  :jobother.sync="jobother"
                  :jobcompt.sync="jobcompt"
                  :jobeducation.sync="jobeducation"
                  v-bind="{ jobOtherFilters, jobTypeFilters, jobCompetitionFilters, jobEducationFilters, hasFilters, vModal: false }"
                />
              </div>
            </template>
            <template v-if="isMq(['sm'])">
              <div class="columns small-24">
                <div class="grid-x align-middle">
                  <div class="cell small-12">
                    <button @click="$modal.show('job-filters')">
                      <i
                        class="fa-filter"
                        :class="filterCount > 0 ? 'fas' : 'fal'"
                      /> Filters {{ filterCount > 0 ? `(${filterCount})` : `` }}
                    </button>
                  </div>
                  <div class="cell small-12 text-right">
                    <button
                      class="jb-clear-all-filters-btn-link"
                      :disabled="!hasFilters"
                      @click="clearAllFilters()"
                    >
                      Clear All Filters
                    </button> &nbsp;
                  </div>
                </div>
              </div>
              <modal
                name="job-filters"
                adaptive
                click-to-close
                height="auto"
                @before-open="vModalBeforeOpen"
                @before-close="vModalBeforeClose"
              >
                <job-filters
                  :class="isMobile.Android() ? 'os-android' : ''"
                  :update-results-list="updateResultsList"
                  :clear-all-filters="clearAllFilters"
                  :jobtype.sync="jobtype"
                  :jobother.sync="jobother"
                  :jobcompt.sync="jobcompt"
                  :jobeducation.sync="jobeducation"
                  v-bind="{ jobOtherFilters, jobTypeFilters, jobCompetitionFilters, jobEducationFilters, hasFilters, vModal: true }"
                />
              </modal>
            </template>

            <!-- Results -->
            <div class="columns small-24 medium-17">
              <div
                v-if="(featJobs.length == 1 || featJobs.length == 2) && !hasFilters"
                class="row"
              >
                <div class="columns">
                  <h2 class="jb-featured-jobs-title">
                    Featured job{{ featJobs.length > 1 ? 's' : '' }}
                  </h2>
                </div>
              </div>
              <!-- Featured Jobs - 1 -->
              <div
                v-if="featJobs.length === 1 && !hasFilters"
                class="row jb-featured-jobs"
              >
                <div 
                  v-for="job in featJobs"
                  :key="job.title"
                >
                  <div
                    class="columns small-24"
                  >
                    <div class="jb-feat-job">
                      <a
                        :href="job.link"
                        class="card action-panel"
                        target="_blank"
                      >
                        <div class="panel ">
                          <header class="text-align-left">
                            <div class="float-left mrm">
                              <span
                                class="fa-stack fa-3x center"
                                aria-hidden="true"
                              >
                                <i class="fas fa-circle fa-stack-2x" />
                                <i class="fas fa-briefcase fa-stack-1x fa-inverse" />
                              </span>
                            </div>
                            <h3>{{ job.title }}</h3>
                          </header>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Featured Jobs - 2 -->
              <div
                v-if="featJobs.length === 2 && !hasFilters"
                class="row jb-featured-jobs"
              >
                <div 
                  v-for="job in featJobs"
                  :key="job.link"
                >
                  <div
                    class="columns medium-12"
                  >
                    <div class="jb-feat-job">
                      <a
                        :href="job.link"
                        class="card action-panel"
                        target="_blank"
                      >
                        <div
                          class="panel equal"
                          data-equalizer-watch
                          style="min-height: 270px;"
                        >
                          <header>
                            <div>
                              <span
                                class="fa-stack fa-4x center"
                                aria-hidden="true"
                              >
                                <i class="fas fa-circle fa-stack-2x" />
                                <i class="fas fa-briefcase fa-stack-1x fa-inverse" />
                              </span>
                            </div>
                            <h3>{{ job.title }}</h3>
                          </header>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="align-top">
                <!-- Results Count -->
                <div class="cell small-24 medium-14 small-order-2 medium-order-1">
                  <span v-if="results.length === 0">
                    <span>No results found for </span>
                    <span 
                      v-if="displaySearch.length > 0"
                      class="search-term"
                    >
                      <b><em>"{{ displaySearch }}"</em></b>
                    </span>
                  </span>
                  <span 
                    v-else-if="$refs.paginator"
                    class="search-term"  
                  >
                    Showing {{ start }} – {{ end }} of {{ total }} results
                    <span v-if="displaySearch.length > 0">
                      for <b><em>"{{ displaySearch }}"</em></b>
                    </span>
                  </span>
                  <span>
                    <input
                      v-if="displaySearch.length > 0 && jobcompt.length == 0 && jobother.length == 0 && jobtype.length == 0 && jobeducation.length == 0"
                      type="submit"
                      class="clear-button"
                      value="Clear all"
                      @click="clearAllFilters();"
                    >
                  </span>
                  <div>
                    <span v-if="jobcompt.length > 0 || jobother.length > 0 || jobtype.length > 0 || jobeducation.length > 0">
                      <button
                        v-for="(item, index) in [...jobcompt, ...jobother, ...jobtype, ...jobeducation]"
                        :key="index"
                        class="filter-button"
                        @click="removeFilter(item)"
                      >
                        {{ getCorrespondingName(item).tag }}
                        <i class="far fa-times" />
                      </button>
                    </span>
                    <span>
                      <input
                        v-if="jobcompt.length > 0 || jobother.length > 0 || jobtype.length > 0 || jobeducation.length > 0"
                        type="submit"
                        class="clear-button"
                        value="Clear all"
                        @click="clearAllFilters();"
                      >
                    </span>
                  </div>
                  <div 
                    v-if="results.length === 0" 
                    class="helper-text"
                  >
                    <strong>There are no matching results.</strong>
                    <br>
                    <br>
                    Improve your search results by:
                    <br>
                    <br>
                    <ul>
                      <li>Using different or fewer search terms.</li>
                      <li>Checking your spelling.</li>
                      <li>Removing or adjusting any filters.</li>
                    </ul>
                    Want to start over? Select “Clear all” to reset the search settings.
                  </div>
                </div>
                <!-- Sort By -->
                <div class="cell small-24 medium-10 small-order-1 medium-order-2">
                  <div
                    v-if="results.length > 0"
                    class="jb-sort-by"
                  >
                    <label
                      for="sort-by"
                      aria-label="Sort By"
                    > <span>Sort By</span>
                    </label>
                    <select
                      id="sort-by"
                      v-model="sort"
                      @change="sortResults()"
                    >
                      <option
                        v-for="sortByType in sortByTypes"
                        :key="sortByType"
                        :value="sortByType"
                      >
                        {{ sortByType }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Jobs List -->
              <div class="jb-jobs">
                <paginate
                  ref="paginator"
                  name="results"
                  :list="results"
                  :per="10"
                >
                  <li
                    v-for="job in paginated('results')"
                    :key="job.url"
                  >
                    <!-- Job -->
                    <div class="jb-job">
                      <!-- Job Title -->
                      <div class="jb-job-title-wrap bg-ghost-gray clearfix">
                        <div class="jb-job-title h3">
                          <a
                            :href="job.url"
                            target="_blank"
                          >{{ job.job_title }}</a>
                        </div>
                      </div>
                      <div class="jb-job-tags">
                        <div
                          class="jb-job-tag"
                          :class="getCorrespondingTag(job.job_type).class"
                        >
                          {{ getCorrespondingTag(job.job_type).tag }}
                        </div>
                        <div
                          class="jb-job-tag"
                          :class="getCorrespondingTag(job.contract).class"
                        >
                          {{ getCorrespondingTag(job.contract).tag }}
                        </div>
                        <div
                          v-if="job.competition"
                          class="jb-job-tag"
                          :class="getCorrespondingTag(job.competition).class"
                        >
                          {{ getCorrespondingTag(job.competition).tag }}
                        </div>
                        <div
                          v-if="job.education_required"
                          class="jb-job-tag"
                          :class="getCorrespondingTag(job.education_required).class"
                        >
                          {{ getCorrespondingTag(job.education_required).tag }}
                        </div>
                      </div>
                      <!-- Job Body -->
                      <div class="jb-job-body">
                        <!-- Job Department -->
                        <div
                          v-if="job.department"
                          class="jb-job-dept"
                        >
                          <b>Offered by: </b>{{ job.department }} {{ job.deptAcronym ? `(${job.deptAcronym})` : '' }}
                        </div>
                        <!-- Job Exam Number -->
                        <div
                          v-if="job.exam_number"
                          class="jb-job-exam"
                        >
                          <b>Exam number:</b> {{ job.exam_number }}
                        </div>
                        <!-- Job Open/Close Date -->
                        <div
                          v-if="isDateValid(job.published)"
                          class="jb-job-date"
                        >
                          <template v-if="isDateValid(job.close_date)">
                            <b>Open from:</b>
                          </template>
                          <template v-else>
                            <b>Posted on:</b>
                          </template>
                          {{ toDisplayDate(job.published) }}
                          <template v-if="isDateValid(job.close_date)">
                            <b> - </b> {{ toDisplayDate(job.close_date) }}
                          </template>
                        </div>
                        <!-- Job Salary -->
                        <div
                          v-if="hasSalary(job.salary_start)"
                          class="salary"
                        >
                          <b>Salary:</b> {{ displaySalary(job.salary_start, job.salary_end) }}
                        </div>
                        <!-- Job URL -->
                        <div class="jb-job-url">
                          <a
                            :href="job.url"
                            target="_blank"
                          >Learn more &raquo;</a>
                        </div>
                      </div>
                    </div>
                  </li>
                </paginate>
              </div>
              <div
                v-if="results.length > 0"
                class="jb-pagination"
              >
                <paginate-links
                  for="results"
                  :show-step-links="true"
                  :async="true"
                  :limit="3"
                  :step-links="paginateStepLinks"
                  @change="scrollToTop(); getPaginationRange()"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="row columns text-center"
        >
          <i class="fas fa-spinner fa-spin fa-3x loadingdir" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import Fuse from 'fuse.js';
import VuePaginate from 'vue-paginate';
import VueAnalytics from 'vue-analytics';
import VueMq from 'vue-mq';
import JobFilters from './components/JobFilters.vue';
import VModal from 'vue-js-modal';

/**
* @desc VModal is used for mobile filters only
* @todo Only import it when needed
*/
Vue.use(VModal);

/**
* @desc MediaMatch component, helper for responsive states
*/
Vue.use(VueMq, {
  breakpoints: {
    sm: 640,
    md: 1024,
    lg: 'Infinity',
  },
  defaultBreakpoint: 'sm',
});

/**
* @desc google analytics, only enabled in production
*/
Vue.use(VueAnalytics, {
  id: 'UA-860026-1',
  debug: {
    enabled: process.env.NODE_ENV === 'development',
    sendHitTask: process.env.NODE_ENV === 'production',
  },
});

/**
* @desc pagination component
*/
Vue.use(VuePaginate);
// Vue.use(VTooltip)

/**
* @desc initializes search component; accessible via this.$search
* @returns { Promise }
*/
Vue.prototype.$search = function (term, list, options) {
  return new Promise(function (resolve) {
    var run = new Fuse(list, options);
    var results = run.search(term);
    resolve(results);
  });
};

export default {
  name: 'Jobsboard',
  components: {
    JobFilters,
  },
  data () {
    return {
      api: {
        featJobs: 'https://api.phila.gov/phila/jobs/featured',
        getAllDepartments: 'https://api.phila.gov/phila/department/list',
        getJobs: 'https://phl.carto.com/api/v2/sql?q=select+*+from+job_postings_unified',
      },
      defaultSort: 'Most recent',
      departments: [],
      departmentsWithJobs: [],
      dept: '',
      featJobs: [],
      start: 0, 
      end: 0, 
      total: 0,
      fuseSearchOptions: {
        defaultAll: false,
        keys: [
          'job_title',
          'department',
          'deptAcronym',
        ],
        matchAllTokens: true,
        threshold: 0.2,
        tokenize: true,
      },
      isMobile: {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
      },
      jobs: [],
      jobcompt: [],
      jobCompetitionFilters: [
        {
          label: 'Open to existing City employees',
          matchKey: 'competition',
          matchValue: 'city-only',
          valueStore: 'jobcompt',
        },
        {
          label: 'Open to existing department employees',
          matchKey: 'competition',
          matchValue: 'department-only',
          valueStore: 'jobcompt',
        },
        {
          label: 'Open to anyone',
          matchKey: 'competition',
          matchValue: 'open',
          valueStore: 'jobcompt',
        },
      ],
      jobother: [],
      jobOtherFilters: [
        {
          label: 'Full-Time',
          matchKey: 'contract',
          matchValue: 'Full-Time',
          valueStore: 'jobother',
        },
        {
          label: 'Part-Time',
          matchKey: 'contract',
          matchValue: 'Part-Time',
          valueStore: 'jobother',
        },
        {
          label: 'Intern',
          matchKey: 'contract',
          matchValue: 'Intern',
          valueStore: 'jobother',
        },
        {
          label: 'Contract',
          matchKey: 'contract',
          matchValue: 'Contract',
          valueStore: 'jobother',
        },

      ],
      jobtype: [],
      jobTypeFilters: [
        {
          label: 'Civil service',
          matchKey: 'job_type',
          matchValue: 'Civil Service',
          valueStore: 'jobtype',
        },
        {
          label: 'Non-civil service',
          matchKey: 'job_type',
          matchValue: 'Non-Civil Service',
          valueStore: 'jobtype',
        },
      ],
      jobeducation: [],
      jobEducationFilters: [
        {
          label: 'College degree',
          matchKey: 'education_required',
          matchValue: 'College',
          valueStore: 'jobeducation',
        },
        {
          label: 'High School/GED',
          matchKey: 'education_required',
          matchValue: 'High School/GED',
          valueStore: 'jobeducation',
        },
      ],
      paginate: [ 'results' ],
      paginateStepLinks: {
        next: 'Next',
        prev: 'Previous',
      },
      ready: false,
      results: [],
      routerQuery: {},
      search: '',
      displaySearch: '',
      sort: 'Most recent',
      sortByTypes: [
        'Most recent',
        'Alphabetical',
        'Closing soon',
        'Salary (high to low)',
        'Salary (low to high)',
      ],
    };
  },

  computed: {

    /**
    * @desc checks if ready for display
    * @return { Boolean }
    */
    isReady () {
      return this.ready;
    },

    /**
    * @desc mobile only active filter counter
    * @return { Number }
    */
    filterCount () {
      let count = 0;
      for (let key in this.routerQuery) {
        if ([ 'jobtype', 'jobcompt', 'jobother', 'jobeducation' ].includes(key)) {
          count = parseInt(count) + this.returnArray(this.routerQuery[key]).length;
        }
      }
      return count;
    },

    /**
    * @desc checks if url has filters
    * @returns { Boolean }
    */
    hasFilters () {
      if (Object.keys(this.routerQuery).length > 0) {
        return true;
      }
      return false;
    },
  },
  watch: {
    dept (value) {
      if (value.length > 0) {
        this.updateRouterQuery('dept', value);
      } else {
        this.updateRouterQuery('dept');
      }
    },
    jobtype (value) {
      if (value.length > 0) {
        this.updateRouterQuery('jobtype', value);
      } else {
        this.updateRouterQuery('jobtype');
      }
    },
    jobcompt (value) {
      if (value.length > 0) {
        this.updateRouterQuery('jobcompt', value);
      } else {
        this.updateRouterQuery('jobcompt');
      }
    },
    jobother (value) {
      if (value.length > 0) {
        this.updateRouterQuery('jobother', value);
      } else {
        this.updateRouterQuery('jobother');
      }
    },
    jobeducation (value) {
      if (value.length > 0) {
        this.updateRouterQuery('jobeducation', value);
      } else {
        this.updateRouterQuery('jobeducation');
      }
    },
    routerQuery: {
      handler: function () {
        this.updateRouter();
      },
      deep: true,
    },
    sort (value) {
      if (value.length > 0 && value !== this.defaultSort) {
        this.updateRouterQuery('sort', value);
      } else {
        this.updateRouterQuery('sort');
      }
    },
  },
  async created () {
    await this.init();
    await this.getPaginationRange();
  },
  methods: {
    /**
    * @desc clears all filters.
    * Triggered by clear filters button
    */
    clearAllFilters () {     
      this.$ga.event('job-board', 'click', 'Clear All Filters');
      this.resetFilters();
      this.resetRouterQuery();
      this.updateResultsList();
    },

    /**
    * @desc clears search bar
    */
    clearSearchBar () {
      this.search = '';
      this.updateResultsList();
    },

    /**
    * @desc filters jobs by departments (drop-down)
    * @param { Array } jobs
    * @returns { Array } of filtered jobs
    */
    departmentFilter (jobs) {
      if (this.dept !== '') {
        return jobs.filter((job) => {
          return this.dept === job.department;
        }, this);
      }
      return jobs;
    },

    /**
    * @desc join salaries into single string
    * @param { String } salaryStart
    * @param { String } salaryEnd
    * @returns { String }
    */
    displaySalary(salaryStart, salaryEnd) {
      let display = [];

      if (salaryStart !== 'Not Available') {
        const formattedStart = `$${Number(salaryStart).toLocaleString()}`;
        display.push(formattedStart);
      }

      if (salaryEnd !== 'Not Available') {
        const formattedEnd = `$${Number(salaryEnd).toLocaleString()}`;
        display.push(`- ${formattedEnd}`);
      }

      return display.join(' ');
    },

    /**
    * @desc get official list of departments from phila.gov
    * @returns { Promise }
    */
    async getAllDepartments () {
      let depts = [];
      let self = this;
      return axios.get(this.api.getAllDepartments).then((result) => {
        result.data.forEach((dept) => {
          depts.push(dept.short_name || dept.name);
        });
        depts.push('Multiple departments');
        self.departments = depts;
        return;
      }).catch(error => {
        window.console.log(error);
      });
    },

    /**
    * @desc gets a jobs' tag and css class based on its value
    * @param { String } tag
    * @returns { Object }
    */
    getCorrespondingTag (tag) {
      if (tag !== '') {
        switch (tag) {
        case 'city-only':
          return {
            tag: 'City-Only',
            class: 'bg-light-bell dark-gray',
          };
        case 'department-only':
          return {
            tag: 'Department-Only',
            class: 'bg-light-blue dark-gray',
          };
        case 'open':
          return {
            tag: 'Open to anyone',
            class: 'bg-light-kelly-drive dark-gray',
          };
        case 'Non-Civil Service':
          return {
            tag: 'Non-Civil Service',
            class: 'bg-light-red dark-gray',
          };
        case 'Civil Service':
          return {
            tag: 'Civil Service',
            class: 'bg-pride-purple',
          };
        case 'Intern':
          return {
            tag: 'Intern',
            class: 'bg-phanatic-green',
          };
        case 'Full-Time':
          return {
            tag: 'Full-Time',
            class: 'bg-punk-pink',
          };
        case 'Part-Time':
          return {
            tag: 'Part-Time',
            class: 'bg-dark-gray',
          };
        case 'Contract':
          return {
            tag: 'Contract',
            class: 'bg-flyers-orange',
          };
        case 'College':
          return {
            tag: 'College degree',
            class: 'bg-love-park-red',
          };
        case 'High School/GED':
          return {
            tag: 'High School/GED',
            class: 'bg-electric-blue dark-gray',
          };
        default:
          return {
            tag: tag,
            class: 'bg-dark-gray',
          };
        }
      }
    },

    getCorrespondingName (tag) {
      if (tag !== '') {
        switch (tag) {
        case 'city-only':
          return {
            tag: 'Open to existing City employees',
          };
        case 'department-only':
          return {
            tag: 'Open to existing department employees',
          };
        case 'open':
          return {
            tag: 'Open to anyone',
          };
        default:
          return {
            tag: tag,
            class: 'bg-dark-gray',
          };
        }
      }
    },

    /**
    * @desc Get a max of two featured jobs from phila.gov
    * Featured Jobs are only displayed if also available on all jobs feed
    * @returns { Promise }
    */
    getFeatJobs () {
      let self = this;
      return axios.get(this.api.featJobs).then((response) => {
        let fjobs = response.data;
        self.featJobs = fjobs;
      }).catch(error => {
        window.console.log(error);
      });
    },

    /**
    * @desc Get a list of all jobs from api
    * @returns { Boolean }
    */
    getJobs () {
      let self = this;
      return axios.get(this.api.getJobs).then(async (result) => {
        self.jobs = result.data.rows; 
        await self.matchDepartments(self.jobs);
        self.results = result.data.rows;
        return true;
      }).catch((error) => {
        window.console.log(error);
        return false;
      });
    },

    toDisplayDate(date) {
      return new Intl.DateTimeFormat('en-US').format(new Date(date));
    },

    getPaginationRange: function () {
      let rangeRegex = /^(\d+)-(\d+) of (\d+)$/;
      let matches = rangeRegex.exec(this.$refs.paginator.pageItemsCount);

      if (matches != null) {
        this.start = matches[1];
        this.end = matches[2];
        this.total = matches[3];
      }
      return this.start, this.end, this.total ;
    },

    /**
    * @desc trick to hide mobile keyboard on "enter"
    * Works by shifting focus to another element
    */
    hideMobileKeyboard (e) {
      if (e.type === 'keyup' && e.keyCode === 13) {
        document.getElementsByClassName('search-submit')[0].focus();
      }
    },

    /**
    * @desc initializes app
    */
    async init () {
      this.initFilterState();
      await this.getAllDepartments();
      await this.getJobs();
      await this.getFeatJobs();
      await this.updateResultsList();
      this.ready = true;
    },

    /**
    * @desc gets filters values from url and updates $route
    */
    initFilterState () {
      for (let key in this.$route.query) {
        switch (key) {
        case 'dept':
        case 'search':
        case 'sort':
          Vue.set(this, key, this.$route.query[key]);
          break;
        default:
          Vue.set(this, key, this.returnArray(this.$route.query[key]));
          break;
        }
      }
    },

    /**
    * @desc checks against Invalid Date string (bad output from Date)
    * @param { String } date (from from Date Object in the backend
    * which returns Invalid Date when date is not valid)
    * @returns { Boolean }
    */
    isDateValid (date) {
      if (date !== 'Invalid Date' && typeof date !== 'undefined' && date !== null) {
        return true;
      }
      return false;
    },

    /**
    * @desc uses $mq value to determine responsive size
    * @param { Array } sizes $mq defined sizes
    * @returns { Boolean }
    */
    isMq (sizes) {
      if (!Array.isArray(sizes)) {
        sizes = [ sizes ];
      }
      return sizes.includes(this.$mq);
    },

    /**
    * @desc filters jobs array. All sidebar checkboxes uses this filter
    * @param { Array } jobs
    * @returns { Array } of filtered jobs
    */
    jobFilters (jobs) {
      let jobFilters = [
        ...this.jobCompetitionFilters,
        ...this.jobTypeFilters,
        ...this.jobOtherFilters,
        ...this.jobEducationFilters,
      ];

      jobFilters.forEach(jobFilter => {
        if (this[jobFilter.valueStore].length > 0 && this[jobFilter.valueStore].includes(jobFilter.matchValue)) {
          jobs = jobs.filter(job => {
            return this[jobFilter.valueStore].includes(job[jobFilter.matchKey]);
          });
        }
      });

      return jobs;
    },

    /**
    * @desc checks agains salary Not Available
    * @param { String } salary
    * @returns { Boolean }
    */
    hasSalary (salaryStart) {
      if (salaryStart && salaryStart !== null) {
        return true;
      }
      return false;
    },

    /**
    * @todo part of this functionality has been moved to the server side, could build this list differently now
    * @desc used by @method getJobs to make list of all departments that have availabe positions.
    * which is displayed on the departments drop-down
    * @param { Array } jobs
    */
    matchDepartments (jobs) {
      let self = this;
      jobs.forEach((job) => {
        if (job.department && !self.departmentsWithJobs.includes(job.department) && self.departments.includes(job.department)) {
          self.departmentsWithJobs.push(job.department);
        }
      });
      self.departmentsWithJobs.sort();
    },

    /**
    * @desc resets all filters
    */
    resetFilters () {
      this.dept = '';
      this.jobcompt = [];
      this.jobother = [];
      this.jobtype = [];
      this.jobeducation = [];
      this.search = '';
      this.sort = this.defaultSort;
    },

    /**
    * @desc resets router query
    */
    resetRouterQuery () {
      for (let key in this.$route.query) {
        Vue.delete(this.routerQuery, key);
      }
    },

    /**
    * @desc always returns an array
    * @param { String || Array }
    * @returns { Array }
    */
    returnArray (value) {
      if (Array.isArray(value)) {
        return value;
      }
      if (value !== '') {
        return [ value ];
      }
      return [];


    },

    /**
    * @desc uses Fuse $search to filter jobs
    * @param { Array } jobs
    * @returns { Array } filtered jobs
    */
    searchBarFilter (jobs) {
      if (this.search.length >= 3) {
        this.updateRouterQuery('search', this.search);
        return this.$search(this.search, jobs, this.fuseSearchOptions);
      }
      this.updateRouterQuery('search');
      Vue.delete(this.routerQuery, 'search');
      return jobs;

    },

    /**
    * @desc sorts jobs { Array } by sort drop-down
    */
    sortResults () {
      switch (this.sort) {
      case 'Alphabetical':
        this.results.sort((a, b) => {
          if (a.job_title < b.job_title) {
            return -1;
          }
          if (a.job_title > b.job_title) {
            return 1;
          }
          return 0;
        });
        break;
      case 'Closing soon':
        this.results.sort((a, b) => {
          if (a.close_date === null) {
            return 1;
          }
          if (b.close_date === null) {
            return -1;
          }
          if (a.close_date < b.close_date) {
            return -1;
          }
          if (a.close_date > b.close_date) {
            return 1;
          }
          return 0;
        });
        break;
      case 'Salary (high to low)':
        this.results.sort((a, b) => {
          let aS = parseFloat(a.salary_start.replace(/,/g, '.'));
          let bS = parseFloat(b.salary_start.replace(/,/g, '.'));

          if (isNaN(aS)) {
            return 1;
          }

          if (isNaN(bS)) {
            return -1;
          }

          return bS - aS;
        });
        break;
      case 'Salary (low to high)':
        this.results.sort((a, b) => {
          let aS = parseFloat(a.salary_start.replace(/,/g, '.'));
          let bS = parseFloat(b.salary_start.replace(/,/g, '.'));

          if (isNaN(aS)) {
            return 1;
          }

          if (isNaN(bS)) {
            return -1;
          }

          return aS - bS;
        });
        break;
      default:
        this.results.sort((a, b) => {
          if (a.published > b.published) {
            return -1;
          }
          if (a.published < b.published) {
            return 1;
          }
          return 0;
        });
        break;
      }
    },

    /**
    * @desc it does what it says it does.
    */
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },

    /**
    * @desc Filters & sorts all jobs.
    * Every filter and sort action runs through this method.
    */
    async updateResultsList () {
      let filteredJobs = this.jobs;

      filteredJobs = this.departmentFilter(filteredJobs);
      filteredJobs = await this.searchBarFilter(filteredJobs);
      filteredJobs = this.jobFilters(filteredJobs);

      this.results = filteredJobs;
      this.displaySearch = this.search;

      this.$nextTick(() => {
        this.getPaginationRange();
      });

      this.sortResults();
    },

    /**
    * @desc updates routerQuery which tracks all current filters
    * @param { String } key
    * @param { String } value
    */
    updateRouterQuery (key, value) {
      if (typeof value === 'undefined') {
        Vue.delete(this.routerQuery, key);
      } else {
        this.$ga.event('job-board', key, this.returnArray(value).join('|'));
        Vue.set(this.routerQuery, key, value);
      }
    },
    removeFilter (item) {
      if (this.jobcompt.includes(item)) {
        this.jobcompt = this.jobcompt.filter(compt => compt !== item);
      } else if (this.jobother.includes(item)) {
        this.jobother = this.jobother.filter(other => other !== item);
      } else if(this.jobtype.includes(item)) {
        this.jobtype = this.jobtype.filter(type => type !== item);
      } else if(this.jobeducation.includes(item)) {
        this.jobeducation = this.jobeducation.filter(type => type !== item);
      }
      this.updateResultsList();
      
    },
    /**
    * @desc updates $router
    */
    updateRouter () {
      this.$router.push({
        name: 'main',
        query: this.routerQuery,
      });
    },

    vModalBeforeOpen () {
      window.document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    },

    vModalBeforeClose () {
      window.document.getElementsByTagName('body')[0].style.overflow = 'auto';
    },
  },
};
</script>

<style lang="scss">
  //Scoped Css that depends on Phila.gov Standards
  //@todo remove Standard on prod
  #jobboard-app {
    overflow: hidden;

    .jb-job-tag.bg-college-degree {
      background-color: #4C8444,
    }
    .jb-job-tag.bg-high-school-ged {
      background-color:#73564A
    }
    .card.action-panel .panel {
      padding-bottom: 0;
    }
    .combo-search {
      select {
        float: left;
        width: 27.8%;
        margin-bottom: 40px;
        height:3.15rem;
      }
      
      @media screen and (max-width: 39.9375em) {
        select {
          width: 100%;
          float: none;
          margin-bottom: 5px;
        }
        .vue-search {
          width: 100%;
          float: none;
          margin-bottom: 5px;
        }
      }
    }
    .search-term {
      margin-right: 8px;
    }
    .vue-search {
      padding-bottom: 1rem;
      width: 100%;
      position: relative;

    .search-field{
      min-height: 3.8rem;
      border: 2px solid #0f4d90;
      background: white;
    }

    .clear-search-btn {
      position: absolute;
      top: 16px;
      right: 70px;
      padding: 0;
      font-size: 20px;
      background-color: #fff;
      opacity: 0.8;
      cursor: pointer;
      color: rgba(60, 60, 60, 0.5);
        &:hover {
        background: transparent;
        color: black;
      }
    }
    .search-submit{ 
      position: absolute;
      padding: 0.4rem;
      font-size: 2rem;
      font-weight: 400;
      background: #0f4d90;
      color: white;
      top: 0;
      right: 0;
      width: 3.8rem;
      height: 3.8rem;
      cursor: pointer;
    }

    .fa-magnifying-glass{
      font-weight: normal;
    }
  }
    .filter-button{
      margin: 8px 8px 0px 0px;
      padding: 4px;
      border-radius: 4px;
      border: 2px solid transparent;
      background-color: #cfcfcf;
      color: #333333;
      line-height: normal;
      text-transform: capitalize;
      font-weight: normal;
      cursor: pointer;
    }
    .filter-button:hover {
      border-color: #2176d2;
    }
    .filter-button i{
      padding-left: 4px;
    }
    .clear-button{
      margin: 12px 0 0 8px;
      border: none;
      background-color: transparent;
      color: #0f4d90;
      cursor: pointer;
      font-weight: 700;
      text-decoration: underline;
      padding: 0px;
    }
    .helper-text{
      background: rgba(150,201,255,.3);
      padding: 32px;
      margin-top: 2rem;
      width: fit-content;
    }
    .jb-clear-all-btn {
      margin-top: 30px;
    }
    .jb-clear-all-filters-btn-link {
      background-color: #fff;
      color: #0f4d90;
      text-transform: none;
      &:disabled {
        opacity: 0.5;
      }
    }
    h2.jb-featured-jobs-title {
      margin-top: 0;
    }
    .jb-featured-jobs {
      margin-bottom: 30px;
        .action-panel {
          h3 {
            margin-top:0;
            font-size: 1.714rem;
          }
        }
    }
    .in-modal {
      .jb-clear-all-btn {
        margin-top: 0px;
        background-color: #fff;
        color: #0f4d90;
        text-decoration: underline;
        &:disabled {
          opacity: 1 !important;
          color: rgba(15, 77, 144, 0.4) !important;
        }
      }
    }
    .jb-feat-job {
      margin-bottom: 20px;
      .action-panel {
        h3{
          font-size:  1.714rem;
        }
      }
    }
    .jb-sidebar-filters {
      .jb-sidebar-header {
        margin-top: 40px;
        text-transform: uppercase;
        color: #444;
        font-size: 17px;
        font-weight: 700;
        padding: 1.15rem 1rem;
        border-bottom: 1px solid #ccc;
        &.jb-first-sidebar-header {
          margin-top: 0;
        }
      }
      @media screen and (max-width: 39.9375em) {
        height: 100vh;
        .jb-sidebar-filters-wrap {
          min-height: auto;
          max-height: calc(100vh - 85px);
          overflow-y: scroll;
          overflow-x: hidden;
          padding-bottom: 20px;
        }
        &.os-android {
          .jb-sidebar-filters-wrap {
            max-height: calc(100vh - 141px);
          }
        }
      }
    }
    .jb-jobs ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }
    .jb-job {
      margin-bottom: 20px;
    }
    .jb-job-body {
      padding: 10px;
      &:after {
        content: ' ';
        display: table;
        clear: both;
      }
    }
    .jb-job-date {
      margin-bottom: 10px;
    }
    .jb-job-exam {
      margin-bottom: 10px;
    }
    .jb-job-dept {
      margin-bottom: 10px;
    }
    .jb-job-tag {
      display: inline-block;
      line-height: 1;
      padding: 2px 10px;
      background-color: #a1a1a1;
      margin: 3px 2px;
      font-weight: 700;
      color: #fff;
      text-transform: uppercase;
      font-size: 12px;
    }
    .jb-job-tags {
      margin: 10px 0 15px;
      line-height: 1.1;
    }
    .jb-job-title {
      margin: 0 10px 0 0;
      line-height: 1.2;
    }
    .jb-job-title-wrap {
      padding: 7px 10px;
    }
    .jb-job-url {
      float: right;
    }
    .jb-pagination {
      text-align: right;
      .paginate-links {
        text-align: center;
      }
    }
    .jb-sort-by {
      text-align: right;
      span {
        font-weight: 700;
      }
      select {
        width: auto;
        display: inline-block;
        height: 3rem;
      }
    }
    .jb-job-specialty {
      display: inline-block;
      font-size: 14px;
      color: #444;
      margin: 0 5px;
    }
    .jb-results-count {
      margin-right: 8px;
      @media screen and (max-width: 39.9375em) {
        line-height: 1.3;
      }
    }
    .tooltip {
      display: block !important;
      z-index: 10000;
      padding: 0;
      border-radius: 5px;

      .tooltip-inner {
        color: white;
        padding: 10px;
      }

      .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: black;
        z-index: 1;
      }

      &[x-placement^="top"] {
        margin-bottom: 5px;

        .tooltip-arrow {
          border-width: 5px 5px 0 5px;
          border-left-color: transparent !important;
          border-right-color: transparent !important;
          border-bottom-color: transparent !important;
          bottom: -5px;
          left: calc(50% - 5px);
          margin-top: 0;
          margin-bottom: 0;
        }
      }

      &[x-placement^="bottom"] {
        margin-top: 5px;

        .tooltip-arrow {
          border-width: 0 5px 5px 5px;
          border-left-color: transparent !important;
          border-right-color: transparent !important;
          border-top-color: transparent !important;
          top: -5px;
          left: calc(50% - 5px);
          margin-top: 0;
          margin-bottom: 0;
        }
      }

      &[x-placement^="right"] {
        margin-left: 5px;

        .tooltip-arrow {
          border-width: 5px 5px 5px 0;
          border-left-color: transparent !important;
          border-top-color: transparent !important;
          border-bottom-color: transparent !important;
          left: -5px;
          top: calc(50% - 5px);
          margin-left: 0;
          margin-right: 0;
        }
      }

      &[x-placement^="left"] {
        margin-right: 5px;

        .tooltip-arrow {
          border-width: 5px 0 5px 5px;
          border-top-color: transparent !important;
          border-right-color: transparent !important;
          border-bottom-color: transparent !important;
          right: -5px;
          top: calc(50% - 5px);
          margin-left: 0;
          margin-right: 0;
        }
      }

      &.popover {
        $color: #f9f9f9;

        .popover-inner {
          background: $color;
          color: black;
          padding: 24px;
          border-radius: 5px;
          box-shadow: 0 5px 30px rgba(black, .1);
        }

        .popover-arrow {
          border-color: $color;
        }
      }

      &[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
      }

      &[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
      }

      &.info {
        $color: #004499;
        .tooltip-inner {
          background: $color;
          color: white;
          border-radius: 5px;
          box-shadow: 0 5px 30px rgba(black, .3);
          max-width: 300px;
          font-size: 14px;
        }
        .tooltip-arrow {
          border-color: $color;
        }
      }
    }
    input[type=checkbox] {
      &:disabled {
        + label {
          opacity: 0.4
        }
      }
    }
    .v--modal-overlay {
      z-index: 999999 !important;
      // overflow: auto;
      // background-color: #fff;
    }
    .v-modal-btns {
      background-color: #fff;
      z-index: 999;
      text-align: center;
      margin-top: 20px;
    }
    .checkbox-wrap {
      label {
        line-height: 1.2;
        margin-bottom: 10px;
        div {
          display: inline-block;
          vertical-align: top;
          max-width: 230px;
        }
      }
      @media screen and (max-width: 39.9375em) {
        margin: 10px 0 0 10px;
        label {
          font-size: 18px;
          width: 100%;
          margin-right: 0;
          div {
            max-width: 280px;
          }
        }
      }
    }
  }
</style>

